import { FC, PropsWithChildren } from 'react';

import { Box, ChevronDownOutline, PopoverTrigger, StyleProps, useTabsContext } from '@bonusly/design-system';

import { useHighlightTabDropdownContext } from './context';
import { getStyle } from './style';

interface HighlightTabTriggerProps extends PropsWithChildren, StyleProps {}

export const HighlightTabTrigger: FC<HighlightTabTriggerProps> = ({ children, ...rest }) => {
	const { indexOffset } = useHighlightTabDropdownContext();
	const { selectedIndex } = useTabsContext();

	const isSelected = selectedIndex >= indexOffset;

	return (
		<PopoverTrigger>
			<Box as="button" {...getStyle(isSelected)} {...rest}>
				{children}
				<ChevronDownOutline size="xs" ml={1} />
			</Box>
		</PopoverTrigger>
	);
};
